import { afterNextRender, AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { Header } from './interfaces/header.interface';


@Component({
  selector: 'app-contenedor-elementos',
  templateUrl: './contenedor-elementos.component.html',
  styleUrl: './contenedor-elementos.component.css'
})
export class ContenedorElementosComponent{
  @Input()header: Header;

  value = '';

  ngOnChanges(){
    this.value = `"${this.header.title} ${this.header.subtitles?.length ?' | ':''}
    ${this.header.subtitles?.length ? this.header.subtitles.map(s => s.text).join(' | ') : ''}
    ${this.header.chips?.length ?' | ':''}
    ${this.header.chips?.length ? this.header.chips.map(s => s.text).join(' | ') : ''}`;
  }
}
